import React from 'react';
export function Header() {
  return <header className="w-full px-4 py-4" style={{
    backgroundColor: '#31192E'
  }} data-id="element-45">
      <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-46">
        <div className="flex items-center" data-id="element-47">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4b9E9tPwjTuHvsf8wFUPZj/Group_44.png" alt="Fifth Door" className="h-8 brightness-0 invert" height="30px" data-id="element-48" />
        </div>
        <div className="flex items-center gap-6" data-id="element-49">
          <a href="https://jobs.gem.com/fifthdoor-com" className="text-white font-semibold hover:opacity-80 transition-opacity duration-300" data-id="element-50">
            Careers
          </a>
          <a href="https://discord.gg/HCC76Zt82Y" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity duration-300" aria-label="Join our Discord" data-id="element-51">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bCTwQuQg1RHyDN81pzL1uF/discord-icon-43736.png" alt="Discord" className="w-6 h-6 brightness-0 invert" data-id="element-52" />
          </a>
        </div>
      </div>
    </header>;
}